module.exports = __webpack_public_path__ + "static/img/img.f452e304.png";